import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { CaseCorrectionBreadcrumbsHistory } from './functions';

const CaseCorrectionBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="case-correction-breadcrumbs"
      history={CaseCorrectionBreadcrumbsHistory(t, location)}
    />
  );
};

export default CaseCorrectionBreadcrumbs;
